import { render, staticRenderFns } from "./BookingSlotView.vue?vue&type=template&id=cc2fde7a&scoped=true&"
import script from "./BookingSlotView.vue?vue&type=script&lang=js&"
export * from "./BookingSlotView.vue?vue&type=script&lang=js&"
import style0 from "./BookingSlotView.vue?vue&type=style&index=0&id=cc2fde7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2fde7a",
  null
  
)

export default component.exports